import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { useLocation, useParams } from 'react-router-dom';
import { tokens } from '../theme/tokens';
import { OFFICE_HOME } from '../routes/routes';
import PersonChip from './PersonChip';
import SearchPaletteModal from './SearchPaletteModal';

const buildPath = (pattern, officeId) => pattern.replace(':officeId', officeId);

const OfficeTopBar = () => {
  const location = useLocation();
  const { officeId } = useParams();
  const [paletteOpen, setPaletteOpen] = useState(false);

  const isOfficeHomeView = location.pathname === buildPath(OFFICE_HOME, officeId);

  useEffect(() => {
    if (!isOfficeHomeView) return;
    const handler = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setPaletteOpen(true);
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isOfficeHomeView]);

  return (
    <>
      <Box
        component="header"
        sx={{
          height: 70,
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          px: 3.75,
          position: 'sticky',
          top: 0,
          backgroundColor: 'rgba(255,255,255,.78)',
          backdropFilter: 'blur(14px)',
          borderBottom: `1px solid ${tokens.colors.line}`,
          zIndex: 20,
        }}
      >
        {isOfficeHomeView && (
          <Box
            onClick={() => setPaletteOpen(true)}
            sx={{
              flex: 1,
              maxWidth: 520,
              display: 'flex',
              alignItems: 'center',
              gap: 1.25,
              backgroundColor: tokens.colors.panel,
              border: `1px solid ${tokens.colors.line2}`,
              borderRadius: `${tokens.radius.md}px`,
              px: 1.75,
              py: 1.25,
              color: tokens.colors.muted,
              cursor: 'text',
              transition: 'border-color .15s',
              '&:hover': { borderColor: 'rgba(108,114,255,.5)' },
            }}
          >
            <SearchRoundedIcon sx={{ fontSize: 18 }} />
            <Typography sx={{ fontSize: 14, color: tokens.colors.muted }}>
              Busca expedientes, clientes o documentos…
            </Typography>
            <Typography
              sx={{
                ml: 'auto', fontSize: 11, color: tokens.colors.muted,
                backgroundColor: tokens.colors.panel2, border: `1px solid ${tokens.colors.line}`,
                borderRadius: `${tokens.radius.sm}px`, px: 0.75, py: 0.25,
              }}
            >
              ⌘K
            </Typography>
          </Box>
        )}

        <Box sx={{ flex: 1 }} />

        <PersonChip />
      </Box>

      {isOfficeHomeView && (
        <SearchPaletteModal open={paletteOpen} onClose={() => setPaletteOpen(false)} officeId={officeId} />
      )}
    </>
  );
};

export default OfficeTopBar;